import TangramOptions from "./TangramOptions";
import Tangrams from "./Tangrams"
import { useEffect, useState } from "react";

export default function Level5_Tangrams2(props) {
  return(
  <Tangrams {...props} plevel="Level2" img="Butterfly" progression={false} ></Tangrams>
  )
}

